import { create } from "zustand";

/**
 * Режим стримера — как в Discord: на трансляции не видно личного (почта,
 * коды приглашений), не всплывают оповещения и не звучат звуковые сигналы.
 * Выбор хранится на устройстве: стримят обычно с одного.
 */
const KEY = "airel.streamer";

function read(): boolean {
  try {
    return localStorage.getItem(KEY) === "1";
  } catch {
    return false;
  }
}

export const useStreamer = create<{ on: boolean }>()(() => ({ on: read() }));

export function setStreamer(on: boolean) {
  useStreamer.setState({ on });
  try {
    if (on) localStorage.setItem(KEY, "1");
    else localStorage.removeItem(KEY);
  } catch {
    // Не записалось — режим доживёт до конца сеанса в памяти.
  }
}
